"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwinPanelPicker = exports.StyledSelectionButton = exports.StyledFooterButtons = exports.StyledDoneButton = exports.ShortcutActions = exports.SearchIcon = exports.SearchBox = exports.ScrollableArea = exports.Option = exports.Notice = exports.MainSection = exports.Highlight = exports.Heading = exports.HeaderSection = exports.FooterSection = exports.Column = exports.CheckmarkIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
var _checkmark = _interopRequireDefault(require("./checkmark.svg"));
var _search = _interopRequireDefault(require("./search.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//assets

//constants
var borderColor = 'rgba(0, 0, 0, 0.1)';
var expectedLineHeight = 24;
var gapX = 24;
var gapY = 8;
var iconSize = 20;

//derivative constants
var expectedOptionHeight = expectedLineHeight + gapY * 2;
var searchIconX = gapX;
var searchIconY = (gapY * 2 + expectedLineHeight - iconSize) / 2;

//functions
var getScrollableHeight = function getScrollableHeight(numberOfLines) {
  return numberOfLines * expectedOptionHeight + gapY * 2;
};
var TwinPanelPicker = exports.TwinPanelPicker = _styledComponents["default"].div.withConfig({
  displayName: "styles__TwinPanelPicker",
  componentId: "sc-rhj3ri-0"
})([""]);
var Column = exports.Column = _styledComponents["default"].div.withConfig({
  displayName: "styles__Column",
  componentId: "sc-rhj3ri-1"
})(["flex-basis:0;flex-grow:1;min-width:0;overflow:hidden;&:not(:first-child){border-left:1px solid ", ";}", ""], borderColor, function (p) {
  return p.isRelative && "\n    position: relative;\n  ";
});
var FooterSection = exports.FooterSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__FooterSection",
  componentId: "sc-rhj3ri-2"
})(["border-top:1px solid ", ";display:flex;justify-content:space-between;padding:12px ", "px;"], borderColor, gapX);
var HeaderSection = exports.HeaderSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderSection",
  componentId: "sc-rhj3ri-3"
})(["border-bottom:1px solid ", ";font-size:16px;padding:12px ", "px;"], borderColor, gapX);
var Heading = exports.Heading = _styledComponents["default"].div.withConfig({
  displayName: "styles__Heading",
  componentId: "sc-rhj3ri-4"
})(["border-bottom:1px solid ", ";overflow:hidden;padding:", "px ", "px;text-overflow:ellipsis;white-space:nowrap;&:empty::after{content:'\\a0';}"], borderColor, gapY, gapX);
var MainSection = exports.MainSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__MainSection",
  componentId: "sc-rhj3ri-5"
})(["display:flex;"]);
var Highlight = exports.Highlight = _styledComponents["default"].span.withConfig({
  displayName: "styles__Highlight",
  componentId: "sc-rhj3ri-6"
})(["background:rgba(255,217,84,0.5);border-radius:2px;"]);
var Notice = exports.Notice = _styledComponents["default"].div.withConfig({
  displayName: "styles__Notice",
  componentId: "sc-rhj3ri-7"
})(["color:", ";padding:", "px ", "px;"], _palette.commonPalette.txLightGrey, gapY, gapX);
var Option = exports.Option = _styledComponents["default"].div.attrs(function (p) {
  return {
    className: p.isSelectedByKeyboard && 'select-dropdown-keyboard-focus'
  };
}).withConfig({
  displayName: "styles__Option",
  componentId: "sc-rhj3ri-8"
})(["cursor:pointer;overflow:hidden;padding:", "px ", "px;text-overflow:ellipsis;", " white-space:nowrap;&:hover{background:", ";}", ""], gapY, gapX, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? "color:".concat(_palette.commonPalette.disabledText, ";") : '';
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled ? 'none' : _palette.commonPalette.hoverGrey;
}, function (p) {
  return p.isSelectedByKeyboard && "\n    background: #eaeaea;\n  ";
});
var ScrollableArea = exports.ScrollableArea = _styledComponents["default"].div.withConfig({
  displayName: "styles__ScrollableArea",
  componentId: "sc-rhj3ri-9"
})(["height:", "px;overflow-y:auto;"], function (p) {
  return getScrollableHeight(p.rows);
});
var CheckmarkIcon = exports.CheckmarkIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__CheckmarkIcon",
  componentId: "sc-rhj3ri-10"
})(["background:url('", "') no-repeat 50% 50% / 100% 100%;display:inline-block;height:", "px;margin-left:-16px;margin-right:4px;vertical-align:middle;visibility:", ";width:", "px;"], _checkmark["default"], iconSize, function (p) {
  return p.isVisible ? 'visible' : 'hidden';
}, iconSize);
var SearchIcon = exports.SearchIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__SearchIcon",
  componentId: "sc-rhj3ri-11"
})(["background:url('", "') no-repeat 50% 50% / 100% 100%;height:", "px;left:", "px;opacity:0.3;position:absolute;top:", "px;width:", "px;"], _search["default"], iconSize, searchIconX, searchIconY, iconSize);
var SearchBox = exports.SearchBox = _styledComponents["default"].input.attrs({
  type: 'search'
}).withConfig({
  displayName: "styles__SearchBox",
  componentId: "sc-rhj3ri-12"
})(["background:none;border-color:", ";border-style:solid;border-width:0 0 1px;display:block;font:inherit;outline:0;padding:", "px ", "px ", "px ", "px;width:100%;&::-webkit-search-cancel-button{display:none;}&::placeholder{color:rgba(0,0,0,0.3);}"], borderColor, gapY, gapX, gapY, searchIconX + iconSize + 5);
var ShortcutActions = exports.ShortcutActions = _styledComponents["default"].div.withConfig({
  displayName: "styles__ShortcutActions",
  componentId: "sc-rhj3ri-13"
})(["display:flex;"]);
var StyledButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-rhj3ri-14"
})(["background:none;border:0;color:", ";cursor:pointer;display:block;outline:0;padding:0;text-decoration:underline;&:hover{color:", ";}&:disabled{color:", ";cursor:default;pointer-events:none;text-decoration:none;}"], _palette.commonPalette.txBlack, _palette.commonPalette.btnGreen, _palette.commonPalette.txLightGrey);
var StyledDoneButton = exports.StyledDoneButton = (0, _styledComponents["default"])(StyledButton).withConfig({
  displayName: "styles__StyledDoneButton",
  componentId: "sc-rhj3ri-15"
})(["margin-left:auto;"]);
var StyledSelectionButton = exports.StyledSelectionButton = (0, _styledComponents["default"])(StyledButton).withConfig({
  displayName: "styles__StyledSelectionButton",
  componentId: "sc-rhj3ri-16"
})(["&:not(:first-child){margin-left:16px;}"]);
var StyledFooterButtons = exports.StyledFooterButtons = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledFooterButtons",
  componentId: "sc-rhj3ri-17"
})(["display:flex;justify-content:space-between;width:200px;"]);
//# sourceMappingURL=styles.js.map